<!--行业内参-->
<template>
<div class="site-content">
  <div class="site-content-banner">
    <img src="./../../assets/hync_banner.png"/>
  </div>
  <div class="site-content-page width-per-100">
    <div class="content-row">
      <div class="content-col">
         <infoPageList-02 title="行业内参" label="INFORMARION" :showTitle="false" :showOrder="false" :showMore="false" :infoPage="infoPage" :infoBlock="infoBlock" count="4" v-on:queryPage="hync_Req"/>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import InfoPageList02 from '../block/InfoPageList02'
import InfoBlock02 from '../block/InfoBlock02'
export default {
  name: 'Report02',
  components: {
    'infoPageList-02': InfoPageList02,
  },
  data() {
    return {
      msg: 'Welcome to Your Vue.js App---template',
      infoBlock:InfoBlock02,
      infoPage:{},
    }
  },
  methods:{
    //行业内参
    hync_Req(params){
          let that=this;
          let result={page:params};
          console.log('父页面查询参数：'+JSON.stringify(params));
          that.$dataApi.referenceLists({
            param:params
          }).then(res =>{
          //console.log('请求Vue-axios结果：'+JSON.stringify(res))
          that.msg=res.msg;
          result.list= res.data.list;
          result.page.total=res.data.total;
          that.infoPage=result;
          console.log('结束请求Vue-axios：'+JSON.stringify(result))
          });
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.width-per-100{
  width:100%;
}
.content-row{
  width:1024px;
  margin:0 auto;
}
.content-row-c1{
  width:100%;
  background:#eee;
}

.content-row-c1 .content-block{
  width:1024px;
  margin:0 auto;
  background:#eee;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Report02.vue